// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import FormPageHeadingComponent from '../../common/molecule/FormPageHeading';

import MyPref from '../organism/MyPreferencesSection.view';
import Anchor from '../../../../common/atoms/Anchor';
import BodyCopy from '../../../../common/atoms/BodyCopy';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../utils/labels/labelUtilty';
import MyPreferenceLabels, {
  ACCOUNT_COMMON_TEST,
  ACCOUNT_PREFERENCES,
} from './MyPreference.labels';

const MyPrefrence = ({ labels, myCommonTestLabels, ...otherProps }) => {
  const myPreferenceLabels = getLabelFromCopyOrFromTranslation(
    ACCOUNT_PREFERENCES,
    MyPreferenceLabels
  );
  const accountCommonTestLabels = getLabelFromCopyOrFromTranslation(
    ACCOUNT_COMMON_TEST,
    MyPreferenceLabels
  );
  return (
    <div>
      <BodyCopy component="div" className="elem-mb-MED account-dashboard-goback-link">
        <Anchor
          fontSizeVariation="xlarge"
          anchorVariation="secondary"
          to="/account?id=account-overview"
          asPath="/account"
        >
          <span className="left-arrow" />
          {renderLabel(accountCommonTestLabels?.lbl_common_backLink, 'lbl_common_backLink')}
        </Anchor>
      </BodyCopy>
      <FormPageHeadingComponent
        heading={renderLabel(myPreferenceLabels?.lbl_prefrence_heading, 'lbl_prefrence_heading')}
        className="margin-none myAccountRightView"
        data-locator="mypreference-header"
      />
      <MyPref labels={labels} {...otherProps} />
    </div>
  );
};

MyPrefrence.propTypes = {
  labels: PropTypes.shape({}),
};

MyPrefrence.defaultProps = {
  labels: {},
};

export default MyPrefrence;
